import { lucideActivity, lucideBriefcaseBusiness, lucideBuilding2, lucideCreditCard, lucideHelpCircle, lucideHome, lucideMegaphone, lucideSettings, lucideUsers } from '@ng-icons/lucide';
import type { CommandPaletteItem } from './command-palette.types';

function buildValue(kind: CommandPaletteItem['kind'], id: string, title: string, keywords: string[] = []): string {
    const extras = keywords.filter(Boolean).join(' ');
    return `${kind}:${id} ${title} ${extras}`.trim();
}

export const COMMAND_PALETTE_NAV_ITEMS: CommandPaletteItem[] = [
    {
        id: 'nav-dashboard',
        kind: 'nav',
        title: 'Dashboard',
        route: '/dashboard',
        value: buildValue('nav', 'dashboard', 'Dashboard', ['home', 'overview']),
        keywords: ['home', 'overview'],
        icon: 'lucideHome',
    },
    {
        id: 'nav-people',
        kind: 'nav',
        title: 'People',
        route: '/crm/people',
        featureKey: 'CRM:people',
        value: buildValue('nav', 'people', 'People', ['contacts', 'crm']),
        keywords: ['contacts', 'crm'],
        icon: 'lucideUsers',
    },
    {
        id: 'nav-companies',
        kind: 'nav',
        title: 'Companies',
        route: '/crm/companies',
        featureKey: 'CRM:companies',
        value: buildValue('nav', 'companies', 'Companies', ['accounts', 'crm']),
        keywords: ['accounts', 'crm'],
        icon: 'lucideBuilding2',
    },
    {
        id: 'nav-leads',
        kind: 'nav',
        title: 'Leads',
        route: '/crm/leads',
        featureKey: 'CRM:leads',
        value: buildValue('nav', 'leads', 'Leads', ['pipeline', 'crm']),
        keywords: ['pipeline', 'crm'],
        icon: 'lucideTarget',
    },
    {
        id: 'nav-deals',
        kind: 'nav',
        title: 'Deals',
        route: '/crm/deals',
        featureKey: 'CRM:deals',
        value: buildValue('nav', 'deals', 'Deals', ['opportunities', 'crm']),
        keywords: ['opportunities', 'crm'],
        icon: 'lucideBriefcaseBusiness',
    },
    {
        id: 'nav-activities',
        kind: 'nav',
        title: 'Activities',
        route: '/activities',
        featureKey: 'Activities:tasks',
        value: buildValue('nav', 'activities', 'Activities', ['tasks', 'timeline']),
        keywords: ['tasks', 'timeline'],
        icon: 'lucideActivity',
    },
    {
        id: 'nav-marketing',
        kind: 'nav',
        title: 'Marketing',
        route: '/marketing',
        featureKey: 'Marketing:campaigns',
        value: buildValue('nav', 'marketing', 'Marketing', ['campaigns', 'email']),
        keywords: ['campaigns', 'email'],
        icon: 'lucideMegaphone',
    },
    {
        id: 'nav-settings',
        kind: 'nav',
        title: 'Settings',
        route: '/settings',
        value: buildValue('nav', 'settings', 'Settings', ['preferences', 'profile']),
        keywords: ['preferences', 'profile'],
        icon: 'lucideSettings',
    },
    {
        id: 'nav-subscription',
        kind: 'nav',
        title: 'Subscription',
        route: '/subscription',
        value: buildValue('nav', 'subscription', 'Subscription', ['billing', 'plans', 'upgrade']),
        keywords: ['billing', 'plans', 'upgrade'],
        icon: 'lucideCreditCard',
    },
    {
        id: 'nav-plan-bills',
        kind: 'nav',
        title: 'Plan & Bills',
        route: '/plan-bills',
        value: buildValue('nav', 'plan-bills', 'Plan & Bills', ['billing', 'plans', 'invoices']),
        keywords: ['billing', 'plans', 'invoices'],
        icon: 'lucideCreditCard',
    },
    {
        id: 'nav-help-center',
        kind: 'nav',
        title: 'Help Center',
        route: '/help-center',
        value: buildValue('nav', 'help-center', 'Help Center', ['support', 'tickets']),
        keywords: ['support', 'tickets'],
        icon: 'lucideHelpCircle',
    },
];

export const COMMAND_PALETTE_ACTION_ITEMS: CommandPaletteItem[] = [
    {
        id: 'action-create-person',
        kind: 'action',
        title: 'Create person',
        route: '/crm/people/create',
        featureKey: 'CRM:people',
        actionId: 'create-person',
        value: buildValue('action', 'create-person', 'Create person', ['new', 'people', 'contact']),
        keywords: ['new', 'people', 'contact'],
    },
    {
        id: 'action-create-company',
        kind: 'action',
        title: 'Create company',
        route: '/crm/companies/create',
        featureKey: 'CRM:companies',
        actionId: 'create-company',
        value: buildValue('action', 'create-company', 'Create company', ['new', 'account']),
        keywords: ['new', 'account'],
    },
    {
        id: 'action-create-lead',
        kind: 'action',
        title: 'Create lead',
        route: '/crm/leads/create',
        featureKey: 'CRM:leads',
        actionId: 'create-lead',
        value: buildValue('action', 'create-lead', 'Create lead', ['new', 'pipeline']),
        keywords: ['new', 'pipeline'],
    },
    {
        id: 'action-create-deal',
        kind: 'action',
        title: 'Create deal',
        route: '/crm/deals/create',
        featureKey: 'CRM:deals',
        actionId: 'create-deal',
        value: buildValue('action', 'create-deal', 'Create deal', ['new', 'opportunity']),
        keywords: ['new', 'opportunity'],
    },
    {
        id: 'action-toggle-theme',
        kind: 'action',
        title: 'Toggle theme',
        actionId: 'toggle-theme',
        value: buildValue('action', 'toggle-theme', 'Toggle theme', ['light', 'dark', 'system', 'appearance']),
        keywords: ['light', 'dark', 'system', 'appearance'],
    },
];
